import React, { FC, useEffect, useReducer, useState } from "react";
import ErrorComponent from "../ErrorComponent";
import Input from "../customhtmlcomponents/Input";
import Button from "../customhtmlcomponents/Button";
import axios from "../../services/ApiConfig";
import { AxiosResponse } from "axios";
import { LoadingCircle } from "../customhtmlcomponents/LoadingCircle";
import { Action, AdminProps, Forening, initialState, State } from "./types";
import GenerateForeningPanel from "./panels/GenerateForeningPanel";
import AdministrateForeningPanel from "./panels/AdministrateForeningPanel";
import {
  downloadFile,
  downloadInntektAndKostnadRapport,
} from "../../utility/downloadFile";
import { URLS } from "../../utility/UrlConstants";
import LoadingSpinnerComponent from "../customhtmlcomponents/LoadingSpinnerComponent";
import getRapportAar from "../../utility/dateUtils";
import { useHistory } from "react-router";

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "setForeningerSok":
      return {
        ...state,
        foreningerSok: action.payload,
      };
    case "setUsername":
      return {
        ...state,
        username: action.payload,
      };
    case "setMatch":
      return {
        ...state,
        match: action.payload,
      };
    case "setLoading":
      return {
        ...state,
        loading: action.payload,
      };
    case "setCurrentForening":
      return {
        ...state,
        currentForening: action.payload,
      };
    case "setForeningList": {
      return {
        ...state,
        foreningList: action.payload,
      };
    }
    case "setSuccessful": {
      return {
        ...state,
        successful: action.payload,
      };
    }
  }
};

const AdminPanel: FC<AdminProps> = ({
  username,
  isAdmin,
  isViewer,
  token,
  setModal,
  message,
  setCurrentForeningReportNumber,
}: AdminProps) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const history = useHistory();
  const [downloading, setDownloading] = useState(false);
  const processingStyle = `${
    downloading ? "hover:opacity-100 hover:cursor-not-allowed" : null
  } bg-sk-primary-blue disabled:bg-gray-400 disabled:text-sk-button-unselected}`;

  const handleChange = (event: any) => {
    dispatch({ type: "setLoading", payload: true });
    handleSearchInput(event);
    if (event.target.value === "")
      dispatch({ type: "setLoading", payload: false });
    dispatch({ type: "setForeningList", payload: [] });
  };
  const handleSearchInput: React.ChangeEventHandler<HTMLInputElement> = async (
    event
  ) => {
    dispatch({
      type: "setForeningerSok",
      payload: event.target.value,
    });
    if (event.target.value.length >= 1) {
      // console.log(token)
      await axios
        .get<Forening[]>(
          `${URLS.ADMIN_FORENING_SOK_GET}${event.target.value.toLowerCase()}`
        )
        .then((response: AxiosResponse<Forening[]>) => {
          console.log(response.data);
          dispatch({ type: "setForeningList", payload: response.data });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          dispatch({ type: "setLoading", payload: false });
        });
    }
    dispatch({ type: "setLoading", payload: false });
  };

  const dropDown = state.foreningList.map((forening) => (
    <li
      key={forening.id}
      id={forening?.id?.toString()}
      onClick={(e) => renderForening(e, forening)}
      className="bg-white border-2 border-sk-secondary-blue shadow-lg hover:bg-blue-700 hover:border-blue-50 border-2"
    >
      {forening.foreningsNummer + "-" + forening.foreningsNavn}
    </li>
  ));

  const renderForening = (e: any, forening: Forening) => {
    dispatch({ type: "setForeningList", payload: [] });
    dispatch({
      type: "setCurrentForening",
      payload: {
        id: forening.id,
        foreningsNavn: forening.foreningsNavn,
        password: "",
        active: forening.active,
        viewer: forening.viewer,
        foreningsNummer: forening.foreningsNummer,
      },
    });
    dispatch({ type: "setMatch", payload: true });
    dispatch({ type: "setForeningerSok", payload: "" });
  };

  const downloadExcel = (year: number) => {
    setDownloading(true);
    axios
      .get(`${URLS.ADMIN_LASTNED_AAR_RAPPORT_GET}/${year}`, { responseType: "blob" })
      .then((response) => {
        downloadFile(response, "xlsx", year, -1);
      })
      .catch((err) => console.error(err))
      .finally(() => setDownloading(false));
  };
  const downloadRegnskapsRapport = () => {
    setDownloading(true);
    axios
      .get(URLS.ADMIN_LASTNED_REGNSKAPSRAPPORT_GET, { responseType: "blob" })
      .then((response) => {
        downloadInntektAndKostnadRapport(response, "xlsx");
      })
      .catch((err) => console.error(err))
      .finally(() => setDownloading(false));
  };
  const handleForeningChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    console.log("HandleCHange", e.target.name, value, e.target.checked)
    // @ts-ignore
    if (e.target.name === "active" || e.target.name === "viewer") {
      //@ts-ignore
      state.currentForening[e.target.name] = e.target.checked;
    } else {
      // @ts-ignore
      state.currentForening[e.target.name] = value;
    }
    dispatch({
      type: "setCurrentForening",
      payload: { ...state.currentForening },
    });
  };

  
  const openOwnReport = () => {
    const foreningsNummer = parseInt(username ?? "");
    setCurrentForeningReportNumber(foreningsNummer);
    history.push({ pathname: "/lokalforening", state: foreningsNummer });
  };

  useEffect(() => {
    dispatch({ type: "setUsername", payload: username });
  }, [state.foreningList, state.foreningerSok, username]);

  const panel = (
    <div className="m-auto self-center rounded pb-10 mx-20">
      <div className="grid grid-cols-1 flex rounded-3xl w-3/3 h-3/3 justify-evenly 2xl:grid-cols-2">
        <div className="bg-sk-button-selected border-2 border-sk-secondary-blue shadow-xl mx-6 p-4  h-3/3 rounded mb-3 2xl:mb-0">
          <h1 className="text-black text-center text-2xl font-bold mt-2py-2">
            {isAdmin ? "Administrer forening" : "Foreningsrapporter"}
          </h1>
          {isViewer && (
            <Button
              type="button"
              onClick={openOwnReport}
              className={`${processingStyle} my-8`}
            >
              Åpne egen rapport
            </Button>
          )}
          <Input
            labelopts={{ labelOn: true, defaultLabelStyle: true }}
            name="foreningerSok"
            label="Søk på foreningsnummer eller foreningsnavn:"
            placeholder="Foreningsnummer eller navn"
            id="foreningerSok"
            className="w-2/4"
            onChange={handleChange}
            autoComplete="off"
          />
          <ul>{dropDown}</ul>
          {state.loading && <LoadingCircle />}
          {state.match && (
            <>
              <AdministrateForeningPanel
                setCurrentForeningReportNumber={setCurrentForeningReportNumber}
                handleForeningChange={handleForeningChange}
                forening={state.currentForening}
                setModal={setModal}
                message={message}
                isViewer={isViewer}
              />
            </>
          )}
          {isAdmin && (
            <>
              <section className="mt-10 border-black">
                <p className="text-base">
                  Trykk på knappene under for å laste ned rapporter til Excel
                </p>
              </section>
              <div className="grid grid-cols-4 mt-4 place-content-evenly">
                <Button
                  className={processingStyle}
                  disabled={downloading}
                  type="button"
                  onClick={() => downloadExcel(getRapportAar)}
                >
                  Årets rapport
                </Button>

                <Button
                  className={processingStyle}
                  disabled={downloading}
                  type="button"
                  onClick={downloadRegnskapsRapport}
                >
                  Regnskaps rapport
                </Button>
                <Button
                  className={processingStyle}
                  disabled={downloading}
                  type="button"
                  onClick={() => downloadExcel(getRapportAar - 1)}
                >
                  Fjorårets rapport
                </Button>
              </div>
            </>
          )}
          
          {downloading && <LoadingSpinnerComponent />}
        </div>
        {isAdmin && <GenerateForeningPanel
          state={state}
          dispatch={dispatch}
          setModal={setModal}
          message={message}
        />}
      </div>
    </div>
  );
  return <>{isAdmin || isViewer ? panel : <ErrorComponent />}</>;
};
export default AdminPanel;
